import { Observable } from 'rxjs';
import { Result, NetworkError } from '../common';
import { EmpresaPermisoEntity } from '../entities/empresa-permiso.entity';

export abstract class EmpresaPermisoRepository {
  abstract getByEmpresa(empresaId: number): Observable<Result<EmpresaPermisoEntity[], NetworkError>>;
  abstract asignar(empresaId: number, permisoId: number): Observable<Result<EmpresaPermisoEntity, NetworkError>>;
}
